/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import { FunctionComponent, useCallback } from "react";
import { IconButton } from "@itwin/itwinui-react";

export interface PaginationDirectionProps {
  direction: "left" | "right";
  value: number;
  disabled?: boolean;
  onClick?: (value: number) => void;
}

export const PaginationDirectionButton: FunctionComponent<PaginationDirectionProps> = ({ direction, value, disabled, onClick: callback }) => {

  const onClick = useCallback(() => {
    if (callback) {
      callback(value);
    }
  }, [callback, value]);

  return <IconButton onClick={onClick} disabled={disabled} styleType="borderless">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      {direction === "left" ? <polygon points="16 7 1.914 7 7.561 1.354 6.854 0.646 0 7.5 6.854 14.354 7.561 13.646 1.914 8 16 8 16 7" /> : <polygon points="0 8 14.086 8 8.439 13.646 9.146 14.354 16 7.5 9.146 0.646 8.439 1.354 14.086 7 0 7 0 8" />}
    </svg>
  </IconButton>;
};

